import corporateQr from './corporate-qr.svg';
import defaultQr from './default-qr.svg';
import elegantQr from './elegant-gold-qr.svg';
import executiveQr from './executive-qr.svg';
import minimalQr from './minimalist-qr.svg';
import modernQr from './modern-minimal-qr.svg';
import neonQr from './neon-qr.svg';
import techwaveQr from './techwave.svg';
import vintageQr from './vintage-qr.svg';
import uploadIcon from './upload-icon.svg';
import abstractQr from './abstract-qr.svg';

import hideDots from './hide-dots.svg';
import showDots from './show-dots.svg';
import smallMargin from './small-margin.svg';
import largeMargin from './large-margin.svg';
import mediumMargin from './medium-margin.svg';
import showThrough from './show-through.svg'


export {
  abstractQr,
  corporateQr,
  defaultQr,
  elegantQr,
  executiveQr,
  minimalQr,
  modernQr,
  neonQr,
  techwaveQr,
  vintageQr,
  uploadIcon,
  hideDots,
  showDots,
  smallMargin,
  largeMargin,
  mediumMargin,
  showThrough
};
